import { isMobilePwaPlatform, type PwaPlatform } from "@award-party/shared";

const CHANGING_PAGE_PREFIXES = [
  "/parties",
  "/admin",
  "/join",
  "/award-shows",
  "/recaps",
] as const;

function normalizePathname(pathname: string): string {
  if (pathname.length > 1 && pathname.endsWith("/")) {
    return pathname.slice(0, -1);
  }
  return pathname;
}

export function pathnameOffersStaleResumeRefresh(pathname: string): boolean {
  const path = normalizePathname(pathname);
  return CHANGING_PAGE_PREFIXES.some(
    (prefix) => path === prefix || path.startsWith(`${prefix}/`),
  );
}

export function shouldOfferStaleResumePrompt({
  installedApp,
  platform,
}: {
  installedApp: boolean;
  platform: PwaPlatform;
}): boolean {
  return installedApp || isMobilePwaPlatform(platform);
}
